var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"iframe-box"},[_c('div',{staticClass:"zhegai"}),_c('iframe',{style:('height:' + _vm.resizeHeight),attrs:{"id":"iframe1","src":_vm.iframeSrc,"frameborder":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }